import { render } from "./_Sidebar.vue?vue&type=template&id=feaccf86&ts=true"
import script from "./_Sidebar.vue?vue&type=script&lang=ts"
export * from "./_Sidebar.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/askom/io.askom.portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__